import { render, staticRenderFns } from "./AppImportTable.vue?vue&type=template&id=e92252da"
import script from "./AppImportTable.vue?vue&type=script&lang=js"
export * from "./AppImportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports